import React, { InputHTMLAttributes, ReactNode } from 'react';
import styles from './styles.module.css';

export interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: boolean;
  disabled?: boolean;
  iconPrimary?: ReactNode;
  iconSecundary?: ReactNode;
  textError?: string;
  required?: boolean;
  onClickIconPrimary?: () => void;
  onClickIconSecundary?: () => void;
}

const getCSSCustomProperty = (
  propertyName: string,
  fallback: string = ''
): string => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    const defaultValues: Record<string, string> = {
      '--color-grey-400': '#9CA3AF',
      '--color-error': '#EF4444',
    };
    return defaultValues[propertyName] || fallback;
  }

  const rootStyles = getComputedStyle(document.documentElement);
  return rootStyles.getPropertyValue(propertyName).trim() || fallback;
};

export const InputText: React.FC<InputTextProps> = ({
  id = 'text',
  type = 'text',
  error = false,
  disabled,
  textError,
  placeholder = 'Preencha',
  label,
  iconPrimary,
  iconSecundary,
  onClickIconPrimary,
  onClickIconSecundary,
  required = false,
  ...props
}) => {
  const bdColor = !error ? '--color-grey-400' : '--color-error';
  const borderColorInput = getCSSCustomProperty(
    bdColor,
    error ? '#EF4444' : '#9CA3AF'
  );

  return (
    <div className={styles.inputTextContainer}>
      <label>
        {label}
        {required && <span className={styles.required}> *</span>}
      </label>
      <div
        className={styles.boxInputText}
        style={{ borderColor: borderColorInput }}
      >
        {iconPrimary && (
          <span
            role={onClickIconPrimary ? 'button' : undefined}
            tabIndex={onClickIconPrimary ? 0 : undefined}
            onClick={onClickIconPrimary}
            onKeyDown={(e) => {
              if (onClickIconPrimary && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClickIconPrimary();
              }
            }}
            style={{ cursor: onClickIconPrimary ? 'pointer' : 'auto' }}
          >
            {iconPrimary}
          </span>
        )}
        <input
          id={id}
          className={styles.inputText}
          name="search"
          type={type}
          placeholder={placeholder}
          {...props}
        />
        {iconSecundary && (
          <span
            role={onClickIconSecundary ? 'button' : undefined}
            tabIndex={onClickIconSecundary ? 0 : undefined}
            onClick={onClickIconSecundary}
            onKeyDown={(e) => {
              if (
                onClickIconSecundary &&
                (e.key === 'Enter' || e.key === ' ')
              ) {
                e.preventDefault();
                onClickIconSecundary();
              }
            }}
            style={{ cursor: onClickIconSecundary ? 'pointer' : 'auto' }}
          >
            {iconSecundary}
          </span>
        )}
      </div>
      {error && <span>{textError}</span>}
    </div>
  );
};
